var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-toolbar',{attrs:{"flat":""}},[_vm._v(" ЭПЛ ")]),_c('v-card-text',[_vm._v(" Электронные путевые листы"),_c('br'),_c('span',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.version))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }